import { render } from "./CompletedHw.vue?vue&type=template&id=60a1ac19&scoped=true"
import script from "./CompletedHw.vue?vue&type=script&lang=js"
export * from "./CompletedHw.vue?vue&type=script&lang=js"

import "./CompletedHw.vue?vue&type=style&index=0&id=60a1ac19&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a1ac19"]])

export default __exports__